import { KpiCalculationType } from "../enums/kpi-calculation-type.enum";
import { UpdateType } from "../shared/enum/update-type.enum";
import { Comment } from 'src/app/models/comment.model';

export interface Kpi{
    id: number;
    name: string;
    unit: string;

    planned?: number;
    achieved?: number;

    isAssessed: boolean;
    noAnswer?: boolean;
    error: boolean;

    deadline?: number;  // month
    weight?: number;
    isCommon?: boolean;
    minExpectation?: number;
    calculationType?: KpiCalculationType;

    aboutUserId: string;
    aboutEmployeeId?: number;
    reviewPeriodId?: number;

    updateType?: UpdateType;

    comments?: Comment[];

    createdBy?: string;
    createdOn?: Date;
    updatedBy?: string;
    updatedOn?: Date;
}

export class KpiModel implements Kpi {
    id = 0;
    name = '';
    unit = '';

    planned? = null;
    achieved? = null;

    isAssessed = false;
    noAnswer = false;
    error = false;

    deadline? = null;  // month
    weight? = null;
    isCommon? = false;
    minExpectation? = null;
    calculationType = KpiCalculationType.GreaterOrEqual;

    aboutUserId: string;
    aboutEmployeeId?: number;
    reviewPeriodId?: number;

    updateType?: UpdateType;
    comments: Comment[] = [];
    
    createdBy?: string;
    createdOn?: Date;
    updatedBy?: string;
    updatedOn?: Date;
}
